const doc = [({"ja":({"adminConstantDayOfWeekShort":({"monday":"月", "tuesday":"火", "wednesday":"水", "thursday":"木", "friday":"金", "saturday":"土", "sunday":"日"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;